import { invitationAdapter, MyOrganizationState, InvitationState } from "@organizations/models";
import { selectMyOrganizationsState, invitationsReducer } from "@organizations/store/reducers";
import { createSelector } from "@ngrx/store";

const { selectAll } = invitationAdapter.getSelectors();

export const selectInvitationsState = createSelector(
  selectMyOrganizationsState,
  (state: MyOrganizationState) => state.invitations as InvitationState
);

export const selectAllInvitations = createSelector(selectInvitationsState, selectAll);

export const selectInvitationsLoading = createSelector(
  selectInvitationsState,
  invitationsReducer.getInvitationsLoading
);

createSelector(selectInvitationsState, invitationsReducer.getInvitationsLoaded);
